document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.collapsible-trigger');
  if (!trigger) return;

  event.preventDefault();

  let content = null;
  const ariaControls = trigger.getAttribute('aria-controls');
  
  if (ariaControls) {
    content = document.getElementById(ariaControls);
  }
  
  if (!content) {
    // Robust fallback: search forward through siblings of the trigger and its parents
    let current = trigger;
    while (current && current.tagName !== 'BODY') {
      let next = current.nextElementSibling;
      while (next) {
        if (next.classList && next.classList.contains('collapsible-content')) {
          content = next;
          break;
        }
        next = next.nextElementSibling;
      }
      if (content) break;
      current = current.parentElement;
    }
  }

  if (!content) {
    console.error('Accordion content not found for trigger:', trigger);
    return;
  }

  const isOpen = trigger.getAttribute('aria-expanded') === 'true' || trigger.classList.contains('is-open');
  
  trigger.setAttribute('aria-expanded', String(!isOpen));
  trigger.classList.toggle('is-open', !isOpen);
  content.classList.toggle('is-open', !isOpen);
  
  if (!isOpen) {
    content.style.height = `${content.scrollHeight}px`;
  } else {
    // Force explicit height before collapsing if it was somehow manipulated
    content.style.height = `${content.scrollHeight}px`;
    content.offsetHeight; // force reflow
    content.style.height = '0px';
  }
});
